import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { getAuthProvider, getAuthType } from "../common/utils/common.fn";

export const useIsLoggedIn = () => {
  const { accounts, inProgress } = useMsal();
  const idToken = localStorage.getItem("idToken");
  const accessToken = localStorage.getItem("accessToken");
  const authType = getAuthType(idToken);
  const authProvider = getAuthProvider();

  // If MSAL is still processing, don't return false yet (wait for it to complete)
  const isMsalProcessing = inProgress !== InteractionStatus.None;

  if (authProvider === "microsoft" || authType === "microsoft") {
    if (isMsalProcessing) {
      return !!(accounts && accounts.length > 0) || !!idToken;
    }
    return !!(accounts && accounts.length > 0) && !!idToken;
  }

  if (authType === "manual" || authProvider === "manual") {
    return !!idToken || !!accessToken;
  }

  // Fallback: if MSAL is processing and we have accounts, consider logged in
  if (isMsalProcessing && accounts && accounts.length > 0) {
    return true;
  }

  return (accounts && accounts.length > 0) || !!idToken || !!accessToken;
};
